import './App.css'
import Userform from './features/Userform'
import WaitRipple from './components/WaitRipple'
import { useAtom } from 'jotai';
import { courseAtom } from './utils/ClassService';
import { useI18n } from './utils/lni18n';

function App() {

  const { languageService: t } = useI18n();


  const [courseData] = useAtom(courseAtom);

  if (courseData === undefined) return <WaitRipple />

  return (
    <>
      <div className="mt-5 align-center">
        <div className='row'>
          <div className='col-md-8'>

            <h3>
              {courseData.Name}
            </h3>
            <div dangerouslySetInnerHTML={{ __html: courseData.CourseDescription }}>
            </div>

          </div>

        </div>

      </div>
      <div>
        <section>
          <div className="row">

            <div className="col-md-6 preserve-white mb-4">
              {t.getText("checkout.product.description", courseData.MonthsForAccess.toString())}
            </div>

            <div className="col-md-6">
              <Userform />
            </div>



            <div className="clearfix"></div>
          </div>


        </section>

      </div>


    </>
  )
}

export default App
